import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IVendedor } from "../../models";

// criar interface
interface IVendedorState{
    vendedores: IVendedor[]
    vendedorSelecionado?: IVendedor
}

// estado inicial do componente, ao carregar a página
const initialState: IVendedorState = {
    vendedores: []
}

const vendedorSlice = createSlice({
    name: 'Vendedor',
    initialState,
    reducers: {
        setVendedoresState(state, action:PayloadAction<IVendedor[]>) {
            state.vendedores = action.payload
        },
        resetVendedoresState(state) {
            state.vendedores = initialState.vendedores
        }
    }
})

export const {
    setVendedoresState,
    resetVendedoresState
} = vendedorSlice.actions

export const vendedorReducer = vendedorSlice.reducer